export enum StepType {
  ByHour,
  ByDay,
  ByWeek,
  ByMonth,
  ByYear,
}
